<span class="cs-loader__icon">
  <l-ring
    *ngIf="hasProgress || variant === 'ring'; else otherLoader"
    [attr.size]="size"
    [attr.color]="color"
    [attr.stroke]="stroke"
    [attr.speed]="speed"
  ></l-ring>

  <ng-template #otherLoader>
    <l-tail-chase
      *ngIf="variant === 'tailChase'; else pinwheelLoader"
      [attr.size]="size"
      [attr.color]="color"
      [attr.speed]="speed"
    ></l-tail-chase>

    <ng-template #pinwheelLoader>
      <l-pinwheel
        [attr.size]="size"
        [attr.color]="color"
        [attr.stroke]="stroke"
        [attr.speed]="speed"
      ></l-pinwheel>
    </ng-template>
  </ng-template>
  <span *ngIf="hasProgress" class="cs-loader__progress">
    {{ progressValue }}%
  </span>
</span>
<span *ngIf="label" class="cs-loader__label">{{ label }}</span>
